var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M7.14886 1.14571C8.55081 0.12713 10.4492 0.127128 11.8511 1.1457L17.1349 4.98462C18.5369 6.00319 19.1235 7.80866 18.588 9.45675L16.5698 15.6682C16.0343 17.3163 14.4985 18.4322 12.7656 18.4322H6.23442C4.50152 18.4322 2.9657 17.3163 2.4302 15.6682L0.411963 9.45676C-0.123534 7.80867 0.463098 6.00319 1.86505 4.98462L7.14886 1.14571Z",
    fill: "#F6D658"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon1);
export default __webpack_public_path__ + "static/media/polygon-1.07cbb2eca301cd2b105fd01d2b7108bd.svg";
export { ForwardRef as ReactComponent };